import {BaseThunkType, InferActionTypes} from "../index";

let initialState = {
    error: null as {} | null
}

export type InitialStateType = typeof initialState;

const error = (state = initialState, action: ActionsType): InitialStateType => {
    switch (action.type) {
        case 'MB/PROMISE/SET_ERROR':
            return {
                ...state,
                error: action.error
            }
        default:
            return state;
    }
}

export const actions = {
    setErrorData: (error: any) => ({
        type: 'MB/PROMISE/SET_ERROR', error
    } as const)
}
type ActionsType = InferActionTypes<typeof actions>
type ThunkType = BaseThunkType<ActionsType>

export const setPromiseError = (error: any): ThunkType => async (dispatch) => {
    dispatch(actions.setErrorData(error));
}

export default error;